export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-die-six-ac667c68f9ead13e05bc15ec8891b01b.svg";